function bindingMode (binding) {
  if (binding && ((binding.modifiers && binding.modifiers.any) || binding.arg === 'any')) return 'ANY'
  if (binding && ((binding.modifiers && binding.modifiers.all) || binding.arg === 'all')) return 'ALL'
  return 'ALL'
}

export function capabilityBindingAllowed (binding, store) {
  if (!store || !store.getters || !store.getters['access/ready']) return false
  const mode = bindingMode(binding)
  const getter = mode === 'ANY' ? store.getters['access/canAny'] : store.getters['access/canAll']
  return typeof getter === 'function' && Boolean(getter(binding && binding.value))
}

function renderCapability (el, binding, store) {
  const allowed = capabilityBindingAllowed(binding, store)
  if (allowed) {
    el.style.display = el.__iamV2CanOriginalDisplay
    el.removeAttribute('aria-hidden')
  } else {
    el.style.display = 'none'
    el.setAttribute('aria-hidden', 'true')
  }
}

export function createCapabilityDirective (store) {
  return {
    inserted (el, binding) {
      el.__iamV2CanOriginalDisplay = el.style.display || ''
      el.__iamV2CanBinding = binding
      renderCapability(el, binding, store)
      if (store && typeof store.subscribe === 'function') {
        el.__iamV2CanUnsubscribe = store.subscribe(mutation => {
          if (mutation && mutation.type.indexOf('access/') === 0) {
            renderCapability(el, el.__iamV2CanBinding, store)
          }
        })
      }
    },
    componentUpdated (el, binding) {
      el.__iamV2CanBinding = binding
      renderCapability(el, binding, store)
    },
    unbind (el) {
      if (typeof el.__iamV2CanUnsubscribe === 'function') el.__iamV2CanUnsubscribe()
      delete el.__iamV2CanUnsubscribe
      delete el.__iamV2CanBinding
      delete el.__iamV2CanOriginalDisplay
    }
  }
}

export function installAccessCapabilities (Vue, store) {
  Vue.prototype.$can = action => store.getters['access/can'](action)
  Vue.prototype.$canAny = actions => store.getters['access/canAny'](actions)
  Vue.prototype.$canAll = actions => store.getters['access/canAll'](actions)
  Vue.directive('can', createCapabilityDirective(store))
}



// WEBPACK FOOTER //
// ./src/directives/access.js